<div class="inner-content flex flex-col items-center justify-center gap-7">
  <div class="container flex flex-col items-center justify-center gap-4">
    <h1 class="raleway">Programaciones didácticas</h1>
    <div class="info-div flex flex-row items-center justify-center">
      <ul>
        <li>
          Si en tu documento tamaño A4 (210x297mm) dejaste 2,5 cm de margen a cada lado, ese será el margen con el que
          imprimiremos tu programación.
        </li>
        <li>
          Respetaremos tu margen, siempre y cuando supere los 2 mm de margen a cada lado, en caso de que sea inferior,
          por ejemplo: 1,5 mm, nuestras máquinas le pondrán un margen de seguridad que oscila entre 2-3 mm.
        </li>
        <li>
          En caso de que tu documento exceda las dimensiones del A4 (210x297mm), este puede llegar con falta de
          contenido ya que no se ajustará la impresión al formato.
        </li>
        <li>
          Y si aún tienes dudas, mira
          <a
            class="font-bold text-black underline"
            href="https://www.instagram.com/p/DLkxQeAs9Ij/?hl=es"
            target="_blank"
            >este vídeo</a
          >
          de ejemplo
        </li>
      </ul>
      <ion-icon class="flex-shrink-0" name="information-circle-outline"></ion-icon>
    </div>
    <ion-checkbox label-placement="end" [(ngModel)]="checked"
      >Confirmo que mi documento es una <strong>programación didáctica</strong> y he revisado el tamaño del documento y
      sus <strong>márgenes</strong>.
    </ion-checkbox>
    <div class="w-100 flex flex-row gap-2">
      <ion-button color="medium-dark" fill="outline" (click)="cancel()">Cancelar</ion-button>
      <ion-button [disabled]="!checked" class="flex-grow" (click)="submit()">Aceptar y continuar</ion-button>
    </div>
  </div>
</div>
